<template>
  <div class="free-practice-root" :style="{ background: activeComponent.backgroundColor }">
    <header v-if="activeComponent.commonHeader" class="common-header-con">
      <div class="header-title">
        {{ $t(activeComponent.title) }}
      </div>
      <md-button class="md-icon-button" @click="closeDialog">
        <img src="@/assets/images/free-practice/simple_close.png" class="header-close" />
      </md-button>
    </header>
    <section>
      <!--------------------------- 选择练习 ---------------------------->
      <TypesOfPractice
        v-if="activeComponent.componentName == 'TypesOfPractice'"
        @choosePractice="choosePractice"
      ></TypesOfPractice>
      <!--------------------------- 组题面板 ---------------------------->
      <TestCreation
        v-else-if="activeComponent.componentName == 'TestCreation'"
        :cardTitle="activeComponent.title"
        :submitLoading="submitLoading"
        :typeOfPractice="typeOfPractice"
        :initialLevel="initialLevel"
        @goBack="goBack"
        @closeDialog="closeDialog"
        @launchPractice="launchPractice"
      ></TestCreation>
      <!--------------------------- 解析输入、结果 ---------------------------->
      <Analyse @goBack="goBack" v-else-if="activeComponent.componentName == 'Analyse'"></Analyse>
      <!--------------------------- 闪卡 ---------------------------->
      <Flashcards
        v-else-if="activeComponent.componentName == 'Flashcards'"
        :questionKey="questionKey"
        :answerKey="answerKey"
        :renderList="renderQuestionList"
        @saveFlashcardsRes="saveFlashcardsRes"
      >
      </Flashcards>
      <!--------------------------- 练习题 ---------------------------->
      <PracticeExercises
        v-else-if="activeComponent.componentName == 'PracticeExercises'"
        :answerKey="answerKey"
        :questionKey="questionKey"
        :exerciseKey="exerciseKey"
        :renderList="renderQuestionList"
        @savePracticeRes="saveFlashcardsRes"
      ></PracticeExercises>
      <!--------------------------- 练习结果 ---------------------------->
      <PracticeResult
        v-else-if="activeComponent.componentName == 'PracticeResult'"
        :levelName="levelName"
        :typeOfPractice="typeOfPractice"
        :practiceResult="practiceResult"
        :answerKey="answerKey"
        :questionKey="questionKey"
        :exerciseKey="exerciseKey"
        :correctCount="correctCount"
        @closeDialog="closeDialog"
      ></PracticeResult>
    </section>
    <el-dialog
      :visible="timerStopDialogVisible"
      width="460px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <div class="tips-title">{{ $t('free_practice_timer_pause') }}</div>
      <div class="tips-content">
        {{ $t('free_practice_timer_pause_desc') }}
      </div>
      <div class="seconds">
        <img />
        <div>{{ $t('free_practice_seconds', { number: '30' }) }}</div>
      </div>
      <div class="fp-button fp-submit-btn resume-btn" @click="startPractice">
        {{ $t('resume') }}
      </div>
    </el-dialog>
  </div>
</template>
<script>
import TypesOfPractice from '@/components/freePractice/typesOfPractice'
import TestCreation from '@/components/freePractice/testCreation'
import Analyse from '@/components/freePractice/analyse'
import Flashcards from '@/components/freePractice/flashcards'
import PracticeExercises from '@/components/freePractice/practiceExercises'
import PracticeResult from '@/components/freePractice/practiceResult'
import { freePracticeComponentsList } from '@/utils/hskTool'
import { getFreePracticeResource, saveFlashcardRecord } from '@/serves/api/freePractice'
export default {
  props: {
    initialType: {
      type: String,
      default: '',
    },
    initialLevel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      backShow: false,
      titleShow: true,
      typeOfPractice: 'EXERCISE', // 选择类型 FLASHCARDS|EXERCISE|ANALYSE
      currentStep: 1, // 步骤进度：1.选择练习 2.组题面板|解析输入、结果 3.闪卡|练习题 4.答题结果
      renderQuestionList: [],
      answerKey: 'Meaning',
      questionKey: 'Sound',
      exerciseKey: 'Select 1',
      answerTime: 1,
      submitLoading: false,
      timerStopDialogVisible: false,
      timer: null,
      startTime: '', // 开始答题的时间；
      examDurationCount: 0, // 答题所用时长秒；
      practiceResult: null,
      levelName: '',
      correctCount: '',
    }
  },
  created() {
    // 如果有传入初始类型，自动选择并进入下一步
    if (this.initialType) {
      this.typeOfPractice = this.initialType
      this.currentStep = 2
    }
  },
  methods: {
    // 选择练习
    choosePractice(name) {
      this.typeOfPractice = name
      this.currentStep++
    },
    // 关闭当前练习dialog
    closeDialog() {
      this.$emit('closeDialog')
    },
    // 返回上一步
    goBack() {
      this.currentStep--
    },
    async launchPractice(data) {
      console.log(data)
      // 请求必要数据
      this.submitLoading = true
      this.questionKey = data.questionKey
      this.answerKey = data.answerKey
      this.exerciseKey = data.exerciseTypeKey
      this.levelName = data.levelName
      let params = {}
      if (data.isRandom) {
        //随机生成
        params = {
          level_id: data.levelId,
          is_star: data.is_peg == 1 ? true : false,
          random_words_count: data.randomCounts,
        }
      } else {
        params.word_ids = data.allManualSelectionList.map((item) => item.id)
      }
      this.loading = true
      getFreePracticeResource(params)
        .then((res) => {
          if (res.errcode == 0) {
            //资源获取成功，开始答题

            this.renderQuestionList = res.data

            this.currentStep++
            this.startPractice()
          } else {
            this.$message({
              type: 'error',
              message: res.errmsg,
            })
          }
          this.submitLoading = false
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err,
          })
          this.submitLoading = false
        })
    },
    // 提交答题结果(闪卡|选择|判断|连线-多传from参数)
    saveFlashcardsRes(params, from = 'default') {
      if (this.submitLoading) {
        return
      }
      console.log(params, 'free parctice')
      this.pausedPractice()
      let tempTime = this.examDurationCount / 60
      this.correctCount = params.correctCount
      params.answer_time = tempTime < 1 ? 1 : Number(tempTime.toFixed(0))
      if (from == 'default') {
        this.practiceResult = params
      } else if (from == 'Pairs') {
        let resultObj = {
          answer_time: params.answer_time,
          answer_rate: params.answer_rate,
        }
        let optionList = []
        params.answer_list.forEach((list) => {
          list.user_answer.forEach((answer, key) => {
            let chooseIndex = answer.split('-')[0] //获取答案中的自己赋值的index
            let optionItem = list.choose.find((o) => o.index == chooseIndex) // 找到题目的item
            optionItem.user_answer_status = answer == list.right_answer[key] ? '1' : '2'
            optionList.push(optionItem)
          })
        })
        resultObj.answer_list = optionList
        this.practiceResult = resultObj
      }
      this.submitLoading = true
      this.currentStep++
      delete params.correctCount
      saveFlashcardRecord(params)
        .then((res) => {
          if (res.errcode != 0) {
            console.log(res.errmsg)
          }
          this.submitLoading = false
        })
        .catch((err) => {
          console.log(err)
          this.submitLoading = false
        })
    },
    savePrascitcePairsRes(params) {
      if (this.submitLoading) {
        return
      }
      this.pausedPractice()
      let tempTime = this.examDurationCount / 60
      this.correctCount = params.correctCount
      params.answer_time = tempTime < 1 ? 1 : Number(tempTime.toFixed(0))
      // 处理

      this.submitLoading = true
      this.currentStep++
      delete params.correctCount
      saveFlashcardRecord(params)
        .then((res) => {
          if (res.errcode != 0) {
            console.log(res.errmsg)
          }
          this.submitLoading = false
        })
        .catch((err) => {
          console.log(err)
          this.submitLoading = false
        })
    },
    //暂停考试 || 结束考试
    pausedPractice() {
      this.examDurationCount += (new Date().getTime() - this.startTime) / 1000 //累计做题时间
      // this.startTime = new Date().getTime()
      clearTimeout(this.timer) // 取消监听，仍有一个delay时长的timer待执行，手动清除；
      window.removeEventListener('mouseup', this.debounceMouseUp) // 移除鼠标监听事件
      console.log(this.examDurationCount, ' this.examDurationCount')
    },
    //开始考试
    startPractice() {
      this.debounceMouseUp() // 开启定时
      this.timerStopDialogVisible = false //resume操作时隐藏dialog
      this.startTime = new Date().getTime() // 计时开始时间
      window.addEventListener('mouseup', this.debounceMouseUp) // 鼠标点击重新开启定时
    },
    debounceMouseUp() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        this.timerStopDialogVisible = true
        this.pausedPractice()
      }, 30000)
    },
  },
  computed: {
    /**
     * { componentName: String,
         title: String',
         step: Number,
         typeOfPracticeArr: Array,
         commonHeader: Boolean
         }
     */
    activeComponent() {
      let obj = freePracticeComponentsList.find((item) => {
        return (
          item.step === this.currentStep && item.typeOfPracticeArr.includes(this.typeOfPractice)
        )
      })
      return obj ? obj : freePracticeComponentsList[0]
    },
  },
  components: {
    TypesOfPractice,
    TestCreation,
    Analyse,
    Flashcards,
    PracticeExercises,
    PracticeResult,
  },
}
</script>

<style lang="scss">
// 承载本组件的 el-dialog（三处入口都加了 custom-class="free-practice-dialog"）：借用新版原型弹层的外观
// —— 22px 圆角 + 深投影，不渲染 el-dialog 自带的空表头（表头由本组件自己画）
.free-practice-dialog {
  border-radius: 22px !important;
  box-shadow: 0 30px 90px rgba(0, 0, 0, 0.33) !important;
  .el-dialog__header {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
@import '@/components/freePractice/styles/freePractice';
.free-practice-root {
  padding: 0 0 24px;
  border-radius: 22px;
  .common-header-con {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 21px 23px;
    border-bottom: 1px solid #ece7de;
    .header-title {
      color: #2c2f46;
      font-size: 21px;
      font-weight: 700;
      line-height: 1.2;
    }
    // 关闭按钮：34px 圆形浅灰底（原型 .modal-close）
    ::v-deep .md-icon-button {
      width: 34px;
      min-width: 34px;
      height: 34px;
      margin: 0;
      border-radius: 50%;
      background: #f1f2f5;
    }
    .header-close {
      width: 14px;
      height: 14px;
      margin-top: 0;
      object-fit: contain;
    }
  }
}
.tips-title {
  font-size: 32px;
  font-size: bold;
  font-family: 'Inter';
  text-align: center;
  margin-top: -30px;
}
.tips-content {
  font-size: 14px;
  line-height: 20px;
  margin-top: 16px;
  text-align: center;
}
.seconds {
  width: 100%;
  height: 60px;
  background-color: #fafafb;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Inter;
  font-size: 24px;
  color: #515571;
  margin: 12px 0 24px 0;
  div {
    margin-left: 14px;
  }
}
.resume-btn {
  height: 52px;
  line-height: 52px;
  width: 100%;
}
</style>
